import React from "react";

export const Arrow = () => {
  return (
    <svg
      width="43"
      height="37"
      viewBox="0 0 43 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_223_8)">
        <path
          d="M5.98075 17.3267C4.24892 16.6919 4.22653 14.2506 5.94643 13.5841L35.6175 2.08585C37.3875 1.39993 39.0279 3.33481 38.0617 4.96876L32.4524 14.454C32.0721 15.0971 32.082 15.8987 32.4781 16.5322L37.9084 25.2186C38.9181 26.8337 37.3125 28.8122 35.5242 28.1566L5.98075 17.3267Z"
          fill="white"
        />
      </g>
      <g filter="url(#filter1_d_223_8)">
        <path
          d="M12.5686 17.1821C10.8323 16.5491 10.8099 14.1015 12.5344 13.4369L28.3957 7.32371C30.1675 6.64083 31.8045 8.57994 30.834 10.2121L28.401 14.304C28.0173 14.9492 28.0273 15.755 28.4268 16.3905L30.6797 19.9747C31.6936 21.5878 30.0914 23.5707 28.3013 22.918L12.5686 17.1821Z"
          fill="#4485BB"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_223_8"
          x="0.669104"
          y="1.94385"
          width="41.6795"
          height="34.3416"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_223_8"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_223_8"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_223_8"
          x="7.25362"
          y="7.18311"
          width="27.8698"
          height="23.8625"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_223_8"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_223_8"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
